import { useCallback } from 'react';

import { onAnalytics, ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics';

import { BuildPlaybackEventFunction } from './buildPlaybackEvent';
import { PlaybackState } from './playbackState';
import { getAdType } from '../../utils';
import { AdPlayerEventParams } from '../../types';

export const useTriggerOnAdComplete = (buildPlaybackEvent: BuildPlaybackEventFunction) => {
    const triggerOnAdComplete = useCallback(
        (playbackState: PlaybackState | undefined, params: AdPlayerEventParams) => {
            if (!playbackState) return;
            const event = buildPlaybackEvent('AD_COMPLETE', playbackState);
            if (!event) return;

            const assetDuration = (playbackState?.asset?.duration ?? 0) * 1000;
            onAnalytics(ANALYTICS_TRIGGERS.AD_COMPLETE, {
                ...event,
                adId: params.adId,
                adName: params.adName,
                adPosition: getAdType(params.adPosition, assetDuration),
                adPlaybackPosition: params.adDuration, // complete duration of the ad
                adDuration: params.adDuration,
            });
        },
        []
    );

    return triggerOnAdComplete;
};

export const isAdPlaybackCompleted = (
    playbackState: PlaybackState | undefined,
    thresholdPercent = 95
): boolean => {
    if (!playbackState) return false;
    const { currentTime = 0, duration = 0 } = playbackState;
    if (!duration || duration <= 0) return false;
    const percentagePlayed = (currentTime / duration) * 100;
    return percentagePlayed >= thresholdPercent;
};
